import { c as _c } from "react/compiler-runtime";
import { MIN_WIDTH, ROUTES } from "@/utils/constants";
import { useRouter } from "next/router";
import { useEffect } from "react";
interface UseScreenSizeGuardOptions {
  minWidth?: number;
  redirectTo?: string;
}
export const useScreenSizeGuard = t0 => {
  const $ = _c(7);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    minWidth: t2,
    redirectTo: t3
  } = t1;
  const minWidth = t2 === undefined ? MIN_WIDTH : t2;
  const redirectTo = t3 === undefined ? ROUTES.HOME : t3;
  const router = useRouter();
  let t4;
  let t5;
  if ($[2] !== minWidth || $[3] !== redirectTo || $[4] !== router) {
    t4 = () => {
      const checkScreenSize = () => {
        if (window.innerWidth < minWidth) {
          router.replace(redirectTo);
        }
      };
      checkScreenSize();
      let timeoutId;
      const handleResize = () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(checkScreenSize, 150);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        clearTimeout(timeoutId);
        window.removeEventListener("resize", handleResize);
      };
    };
    t5 = [router, minWidth, redirectTo];
    $[2] = minWidth;
    $[3] = redirectTo;
    $[4] = router;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
};